<template>
  <div>
    
    <el-row>
      <el-col :span="24">
        <el-select v-model="costTypeId" placeholder="Select type" size="mini">
          <el-option v-for="item in costType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            @click.native="changeType()">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <!-- Task Fixed Rate -->
        <div v-if="costTypeId == 1">

          <el-row :gutter="20">
            <el-col :span="10">
              <el-input type="number" placeholder="Please input" v-model="price" size="mini">
                <template slot="prepend">Fixed Rate:</template>
              </el-input>
            </el-col>
            <el-col :span="10">
              <el-input type="number" placeholder="Please input" v-model="hours" size="mini">
                <template slot="prepend">Estimated Task Hrs:</template>
              </el-input>
            </el-col>
            <el-col :span="4" style="text-align: end;">
              <el-button type="primary" plain size="mini" @click="save">Save</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-table
                :data="rateReportList"
                style="width: 100%">
                <el-table-column
                  prop="id"
                  label="#"
                  width="40">
                </el-table-column>
                <el-table-column
                  prop="projectTaskProgressText"
                  label="Progress">
                </el-table-column>
                <el-table-column
                  prop="userName"
                  label="User Name">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="spentTime"
                  label="Actual Hours">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="24" style="text-align: end;">
              <el-button type="primary" plain size="mini" @click="save">Save</el-button>
            </el-col>
          </el-row> -->
          
          
        </div>
        <!-- Task Rate/HR -->
        <div v-if="costTypeId == 2">

          <el-row :gutter="20">
            <el-col :span="10">
              <el-input type="number" placeholder="Please input" v-model="price" size="mini">
                <template slot="prepend">Task Rate/HR:</template>
              </el-input>
            </el-col>
            <el-col :span="10">
              <el-input type="number" placeholder="Please input" v-model="hours" size="mini">
                <template slot="prepend">Estimated Task Hrs:</template>
              </el-input>
            </el-col>
            <el-col :span="4" style="text-align: end;">
              <el-button type="primary" plain size="mini" @click="save('2')">Save</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-table
                :data="rateReportList"
                style="width: 100%">
                <el-table-column
                  prop="id"
                  label="#"
                  width="40">
                </el-table-column>
                <el-table-column
                  prop="projectTaskProgressText"
                  label="Progress">
                </el-table-column>
                <el-table-column
                  prop="userName"
                  label="User Name">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="spentTime"
                  label="Actual Hours">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="rate"
                  label="Rate">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="amount"
                  label="Billable">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="24" style="text-align: end;">
              <el-button type="primary" plain size="mini" @click="save">Save</el-button>
            </el-col>
          </el-row> -->
          
        </div>
        <!-- User Rate/HR -->
        <div v-if="costTypeId == 3">

          <el-row :gutter="20">
            <el-col :span="10">
              <el-input type="number" placeholder="Please input" v-model="hours" size="mini">
                <template slot="prepend">Estimated Task Hrs:</template>
              </el-input>
            </el-col>
            <el-col :span="14" style="text-align: end;">
              <el-button type="primary" plain size="mini" @click="save">Save</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-table
                :data="rateReportList"
                style="width: 100%">
                <el-table-column
                  prop="id"
                  label="#"
                  width="40">
                </el-table-column>
                <el-table-column
                  prop="projectTaskProgressText"
                  label="Progress">
                </el-table-column>
                <el-table-column
                  prop="userName"
                  label="User Name">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="spentTime"
                  label="Actual Hours">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="ratePerHour"
                  label="Billable Rate">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="amountUser"
                  label="Total Revenue">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="costRatePerHour"
                  label="Cost Rate">
                </el-table-column>
                <el-table-column
                  align="right"
                  prop="costAmountUser"
                  label="Total Cost">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="24" style="text-align: end;">
              <el-button type="primary" plain size="mini" @click="save">Save</el-button>
            </el-col>
          </el-row> -->

        </div>
      </el-col>
    </el-row>
    
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    props: ['rateCostTypeId'],
    created() {
      this.calculate(this.costTypeId)
    },
    data() {
      return {
        costType: [{
          value: null,
          label: 'Not Selected'
        }, {
          value: 1,
          label: 'Task Fixed Rate'
        }, {
          value: 2,
          label: 'Task Rate/HR'
        }, {
          value: 3,
          label: 'User Rate/HR'
        }],
        costTypeId: null,

        rateReportList: [],
        ratePerHour: null,
        price: null,
        hours: null,

        // Task Fixed Rate
        // Task Rate/HR
        // User Rate/HR
      }
    },
    computed: {
      costTypeStore() {
        return this.$store.state.costType
      },
      rateReport() {
        return this.$store.state.rateReport
      },
    },
    watch: {
      price(val) {
        this.calculate(this.costTypeId)
      },
      hours(val) {
        this.calculate(this.costTypeId)
      },
      costTypeStore(val) {
        this.costTypeId = val.costType
        this.price = val.totalPrice
        this.hours = val.maxHours
        this.ratePerHour = val.ratePerHour
      },
      rateReport(val) {
        console.log('---', val);
        
        let list = []
        let lastRow = {
          id: '',
          userName: '',
          ratePerHour: '',
          costRatePerHour: '',
          spentTime: '',
          rate: '',
          amount: '',
          projectTaskProgressText: '',
        }
        let hoursAll = 0
        let minutesAll = 0
        let id = 1

        for (let i = 0; i < val.length; i++) {
          hoursAll += val[i].spentHours
          minutesAll += val[i].spentMinutes

          let obj = {
            id: '',
            userName: '',
            ratePerHour: '',
            costRatePerHour: '',
            spentTime: '',
            rate: '',
            amount: '',
            projectTaskProgressText: '',
          }

          obj.id = String(id++)

          let progressName = val[i].projectTaskProgressText
          progressName = progressName.slice(3,-4)
          obj.projectTaskProgressText = progressName

          obj.userName = val[i].userName
          obj.ratePerHour = val[i].ratePerHour
          obj.costRatePerHour = val[i].costRatePerHour
          let hours = (val[i].spentHours.toString().length < 2) ? '0' + val[i].spentHours : val[i].spentHours
          let minutes = (val[i].spentMinutes.toString().length < 2) ? '0' + val[i].spentMinutes : val[i].spentMinutes
          obj.spentTime = hours + ':' + minutes

          list.push(obj)
        }
        hoursAll = hoursAll + ((minutesAll - (minutesAll % 60))/60)
        minutesAll = minutesAll % 60
        hoursAll = (hoursAll.toString().length < 2) ? '0' + hoursAll : hoursAll
        minutesAll = (minutesAll.toString().length < 2) ? '0' + minutesAll : minutesAll
        lastRow.spentTime = hoursAll + ':' + minutesAll
        lastRow.projectTaskProgressText = 'Total:'
        lastRow.id = ''

        list.push(lastRow)

        this.rateReportList = list
        this.calculate(this.costTypeId)
      },
    },
    mounted () {
      this.calculate(this.costTypeId)
    },
    methods: {
      changeType() {
        this.price = null
        this.calculate(this.costTypeId)
        // if (this.costTypeId == this.costTypeStore.costType) {
        //   this.$store.dispatch('getCostType')
        // }
      },
      calculate(type) {
        if (type == 2) {
          
          let list = []
          let amountAll = 0
          for (let i = 0; i < this.rateReportList.length; i++) {
            let obj = {
              id: '',
              userName: '',
              ratePerHour: '',
              costRatePerHour: '',
              spentTime: '',
              rate: '',
              amount: '',
              projectTaskProgressText: '',
            }

            obj.id = this.rateReportList[i].id
            
            let progressName = this.rateReportList[i].projectTaskProgressText
            obj.projectTaskProgressText = progressName

            obj.userName = this.rateReportList[i].userName
            obj.ratePerHour = this.rateReportList[i].ratePerHour
            obj.costRatePerHour = this.rateReportList[i].costRatePerHour
            obj.spentTime = this.rateReportList[i].spentTime
            if (i != this.rateReportList.length - 1) {
              obj.rate = this.price
            }

            let hours = this.rateReportList[i].spentTime.slice(0, 2);
            let minutes = this.rateReportList[i].spentTime.slice(3, 5);
            hours = (hours[0] == '0') ? hours[1] : hours
            minutes = minutes = (minutes[0] == '0') ? minutes[1] : minutes

            if (i != this.rateReportList.length - 1) {
              obj.amount = ((this.price / 60) * (+hours * 60 + +minutes)).toFixed(2)
              amountAll += +obj.amount;
            }

            list.push(obj)
          }

          list[list.length - 1].amount = amountAll.toFixed(2)
          list[list.length - 1].projectTaskProgressText = 'Total'
          this.rateReportList = list

        } else if (type == 3) {
          
          let list = []
          let amountAll = 0
          let costAmountAll = 0
          for (let i = 0; i < this.rateReportList.length; i++) {
            let obj = {
              id: '',
              userName: '',
              ratePerHour: '',
              costRatePerHour: '',
              spentTime: '',
              rate: '',
              amountUser: '',
              costAmountUser: '',
              projectTaskProgressText: '',
            }

            obj.id = this.rateReportList[i].id

            let progressName = this.rateReportList[i].projectTaskProgressText
            obj.projectTaskProgressText = progressName

            obj.userName = this.rateReportList[i].userName
            obj.ratePerHour = this.rateReportList[i].ratePerHour
            obj.costRatePerHour = this.rateReportList[i].costRatePerHour
            obj.spentTime = this.rateReportList[i].spentTime
            obj.rate = this.price
            let hours = this.rateReportList[i].spentTime.slice(0, 2);
            let minutes = this.rateReportList[i].spentTime.slice(3, 5);
            hours = (hours[0] == '0') ? hours[1] : hours
            minutes = minutes = (minutes[0] == '0') ? minutes[1] : minutes

            if (i != this.rateReportList.length - 1) {
              obj.amountUser = ((this.rateReportList[i].ratePerHour / 60) * (+hours * 60 + +minutes)).toFixed(2)
              amountAll += +obj.amountUser;
              obj.costAmountUser = ((this.rateReportList[i].costRatePerHour / 60) * (+hours * 60 + +minutes)).toFixed(2)
              costAmountAll += +obj.costAmountUser
            }

            list.push(obj)
          }

          list[list.length - 1].amountUser = amountAll.toFixed(2)
          list[list.length - 1].costAmountUser = costAmountAll.toFixed(2)
          list[list.length - 1].projectTaskProgressText = 'Total'
          this.rateReportList = list
        }
      },
      save(type) {
        let ratePerHour, price
        let obj = {
          costType: this.costTypeId,
          ratePerHour: this.ratePerHour,
          maxHours: this.hours,
          totalPrice: this.price,
        }

        if (type == 2) {
          obj.ratePerHour = this.price
          obj.totalPrice = this.price
        } 
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTasks/changeRateData?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.$route.query.taskId}`, obj)
          .then(response => {
            console.log('---/projectTasks/changeRateData', response.data)
            this.notification("Success", "Save Rate", "success");
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
.el-row { 
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0px;
  }
}

tr.el-table__row {
  &:last-child {
    font-weight: bold !important;
  }
}
</style>